import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersCreate } from '../../../adminSlice';

export default class AddInputFormsForAnswers  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            
            userInputContent: '',
            userInputFeedback: '',
            userInputValue: '',
          
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
       this.handleUserInputFeedback = this.handleUserInputFeedback.bind(this);
       this.handleUserInputValue = this.handleUserInputValue.bind(this);
      // this.handleUserInputId = this.handleUserInputId.bind(this);
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;
        const item = {
            answer_content: this.state.userInputContent,
            answer_feedback: this.state.UserInputFeedback,
            answer_value: this.state.UserInputValue,

            question_id: this.props.adminState.selectedQuestion,
            quiz_id: this.props.adminState.selectedQuize
            
        }
        console.log(item);
        dispatch(idAnswersCreate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}
handleUserInputFeedback(e) {
    this.setState(
        {
            UserInputFeedback: e.target.value
        }
    )
}
handleUserInputValue(e) {
    this.setState(
        {
            UserInputValue: e.target.value
        }
    )
}




// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
   // let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openAddInputFormsForAnswers) {
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новый ответ:</p>
             <form>
             
                 <label>
                     Ответ: </label>
                 <textarea  onChange={this.handleUserInputContent} 
                 ></textarea>
                 


                 <label>
                     Значение(100/0-да/нет)</label>
                 <input id="value" type="text"  onChange={this.handleUserInputValue} 
                 />
                


                 



             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}